import React from "react";
import LiveDriverMap from "@/components/LiveDriverMap";

export default function TrackDriver() {
  return (
    <div className="space-y-6 animate-fade-up" data-testid="track-driver-page">
      <div>
        <p className="overline">Live GPS</p>
        <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-black tracking-tighter mt-1">Track driver</h1>
      </div>
      <LiveDriverMap heightClass="h-[65vh]" />
    </div>
  );
}
